import type { KestrelStores, ServerResult } from "@kestrel/stores";
import * as Internal from "@kestrel/internal/client";
import { getAssignments } from "@otto-ec/global-resources/onex";
import { getLogger } from "@kestrel/client";
import { updateCallback } from "../stores/index-universal.js";
import { goto } from "../stores/goto.js";
import { getNavigationTargetFromUrl } from "../stores/utils.js";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const resolveAsyncData = async (
  ssrState: ServerResult,
  stores: KestrelStores,
): Promise<unknown> => {
  /*                                                                         */
  /*                      */
  if (Internal.experimental.useRenderMethod && !ssrState.error && !ssrState.dataReady) {
    const to = await getNavigationTargetFromUrl(stores, undefined);
    return goto(stores, {}, to, "goto", updateCallback);
  }
};

/**
 *
 *
 *
 *
 *
 *
 *
 */
export const resolveOnexAssignments = async (): Promise<unknown> => {
  /*                                                                       */
  if (Internal.onexEnabled)
    return getAssignments()
      .with({ timeout: 500 })
      .catch((e) => getLogger("entry-points").warn("Onex assignments wait failed", e));
};
